/** Keep newline characters in translated labels. Layout rules that set nowrap still win. */
export const localeLineBreakComponents = {
    MuiCssBaseline: {
        styleOverrides: {
            body: { whiteSpace: "pre-line" },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: { whiteSpace: "pre-line" },
        },
    },
    MuiChip: {
        styleOverrides: {
            root: { whiteSpace: "pre-line" },
            label: { whiteSpace: "pre-line" },
        },
    },
};
//# sourceMappingURL=localeLineBreaks.js.map